import {
  ChartWrapper,
  HorizontalBarChart,
  type HorizontalBarProps,
  LineChart,
  type LinechartProps,
} from "components/charts";
import "../flowPerformance.scss";
import { RequestStatusRenderer } from "components/requestStatsRenderer/RequestStatusRenderer";
import { type RequestState } from "features/Application/globaltypes/fetchRequest";
import {
  sharedAccountReportingHorizontalBarProps,
  sharedAccountReportingLineProps,
} from "features/Reporting/Content/shared";
import CardReporting, { type CardReportingItem } from "components/cards/CardReporting/CardReporting";
import { noBarData, noData } from "features/Library/Common/utils/performanceUtils";
import { getGoalChartProps } from "features/Reporting/MsGraph/shared/constants";

export interface Props {
  header: string;
  goalLineChart: LinechartProps;
  goalLineState: RequestState<any>;
  goalEngagement: HorizontalBarProps;
  goalTotalsState: RequestState<any>;
  goalCardsItems: CardReportingItem[];
  goalCardsState: RequestState<any>;
}

export const UsageCharts = ({
  header,
  goalLineChart,
  goalLineState,
  goalEngagement,
  goalTotalsState,
  goalCardsItems,
  goalCardsState,
}: Props) => {
  return (
    <div className="flowPerformanceApplication">
      <h2>{header}</h2>
      <div className="ct">
        <ChartWrapper {...getGoalChartProps(header)}>
          <RequestStatusRenderer state={goalLineState}>
            {goalLineChart.xData.length > 0 ? (
              <LineChart {...sharedAccountReportingLineProps} {...goalLineChart} />
            ) : (
              noData(null)
            )}
          </RequestStatusRenderer>
        </ChartWrapper>
        <ChartWrapper titles={["Activity by Type"]}>
          <RequestStatusRenderer state={goalTotalsState}>
            {noBarData(...(goalEngagement?.data?.map((d) => d.value) || [])) ? (
              noData(null)
            ) : (
              <HorizontalBarChart {...sharedAccountReportingHorizontalBarProps} {...goalEngagement} />
            )}
          </RequestStatusRenderer>
        </ChartWrapper>
      </div>
      <div className="cr">
        <RequestStatusRenderer state={goalCardsState}>
          <CardReporting items={goalCardsItems} />
        </RequestStatusRenderer>
      </div>
    </div>
  );
};
